export default [
  {
    path: "/semesters",
    name: "semesters",
    component: () => import("@/views/pages/semesters/Semesters.vue"),
    meta: {
      hasPermission: true,

      pageTitle: "ترم ها",
      breadcrumb: [
        {
          text: "ترم ها",
          active: true,
        },
      ],
    },
  },
  {
    path: "/semesters/add",
    name: "add-semester",
    component: () =>
      import("@/views/pages/semesters/semester-form/semesterForm.vue"),
    meta: {
      hasPermission: true,

      pageTitle: "اضافه کردن ترم",
      breadcrumb: [
        {
          text: "ترم ها",
          to: "/semesters",
        },
        {
          text: "اضافه کردن ترم",
          active: true,
        },
      ],
    },
  },
  {
    path: "/semesters/:id/edit",
    name: "edit-semester",
    component: () =>
      import("@/views/pages/semesters/semester-form/semesterForm.vue"),
    meta: {
      hasPermission: true,

      pageTitle: "ویرایش ترم",
      breadcrumb: [
        {
          text: "ترم ها",
          to: "/semesters",
        },
        {
          text: "ویرایش ترم",
          active: true,
        },
      ],
    },
  },
  {
    path: "/semesters/:id",
    name: "show-semester",
    component: () =>
      import("@/views/pages/semesters/show-semester/ShowSemester.vue"),
    meta: {
      notNeedLogin: true,

      pageTitle: "جزئیات ترم",
      breadcrumb: [
        {
          text: "ترم ها",
          to: "/semesters",
        },
        {
          hasId: true,
          text: "جزئیات ترم",
          active: true,
        },
      ],
    },
  },
  {
    path: "/semesters/:id/users",
    name: "users-semester",
    component: () => import("@/views/pages/users/Users.vue"),
    meta: {
      hasPermission: true,

      pageTitle: "کاربران ترم",
      breadcrumb: [
        {
          text: "ترم ها",
          to: "/semesters",
        },
        {
          hasId: true,
          text: "کاربران ترم",
          active: true,
        },
      ],
    },
  },
];
